import { render, staticRenderFns } from "./T1FooterLinks.vue?vue&type=template&id=b753e6c8&scoped=true&"
import script from "./T1FooterLinks.vue?vue&type=script&lang=js&"
export * from "./T1FooterLinks.vue?vue&type=script&lang=js&"
import style0 from "./T1FooterLinks.vue?vue&type=style&index=0&id=b753e6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b753e6c8",
  null
  
)

export default component.exports